import { render, staticRenderFns } from "./pitch-select-popper.vue?vue&type=template&id=4fa8df4b&"
import script from "./pitch-select-popper.vue?vue&type=script&lang=js&"
export * from "./pitch-select-popper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports